import React, { useState, useRef } from "react";
import PropTypes from "prop-types";

import Icon from "components/Icon";
import Form from "components/Form/Form";
import Textarea from "components/Form/Controls/Textarea";
import { cancel } from "domain/Game/api";
import { noop } from "lodash-es";
import { gameTypeTypes } from "domain/Directories/types";

import AnimatedModal from "components/Modal/AnimatedModal";
import Button from "ui/Button";

const CancelGame = ({ id, history, forgetSearch, gameType, isTraining }) => {
    const [showReasonModal, setShowReasonModal] = useState(false);
    const form = useRef(null);

    const onSuccess = () => {
        //Чистим список игр в поиске чтобы отмененная игра не светилась в списке
        forgetSearch();
        history.push("/");
    };

    const toggleReasonModal = () => setShowReasonModal((show) => !show);

    return (
        <>
            <button
                className={`btn game-controls__cancel`}
                type={`button`}
                onClick={toggleReasonModal}
            >
                <Icon type={`delete`} inheritColor />
                <span className={`hide-desktop-down`}>
                    Отменить {isTraining ? "тренировку" : "игру"}
                </span>
            </button>

            {showReasonModal && (
                <AnimatedModal
                    onClose={toggleReasonModal}
                    closeOnOverlay
                    modificators={[`small-col`, `max-w-628`]}
                    title={"Подтверждение отмены"}
                >
                    {() => (
                        <>
                            <p className="text-center c-gs-medium-em mb-24">
                                {isTraining ? "тренировка" : "игра"} “
                                {gameType.name}” будет отменена. Все участники
                                получат уведомление.
                            </p>
                            <Form
                                id="cancelGame"
                                submit={cancel}
                                refForm={form}
                                onSuccess={onSuccess}
                                onError={noop}
                                className="w-100"
                            >
                                {({ error, invalidFields }) => {
                                    return (
                                        <>
                                            <input
                                                type="hidden"
                                                name="id"
                                                value={id}
                                            />

                                            <div className="mb-24">
                                                <Textarea
                                                    id="cancel_reason"
                                                    name="cancel_reason"
                                                    label="Причина"
                                                    invalidFields={
                                                        invalidFields
                                                    }
                                                    error={error}
                                                />
                                            </div>

                                            <div className="btn-group">
                                                <Button
                                                    primary
                                                    size="medium"
                                                    type="submit"
                                                    mixes={[`w-100`]}
                                                >
                                                    <span className="btn__span">
                                                        Отменить{" "}
                                                        {isTraining
                                                            ? "тренировку"
                                                            : "игру"}
                                                    </span>
                                                </Button>
                                            </div>
                                        </>
                                    );
                                }}
                            </Form>
                        </>
                    )}
                </AnimatedModal>
            )}
        </>
    );
};

CancelGame.propTypes = {
    id: PropTypes.number.isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
    forgetSearch: PropTypes.func.isRequired,
    gameType: gameTypeTypes,
    isTraining: PropTypes.bool,
};

export default CancelGame;
